import { ApiResponse } from "../types/api-response"
import { TopFilterOutput } from "./useTopFilter"
import useAuth from "./useAuth"
import useSWR from "swr"

export interface KLHKResponse {
  uuid: string
  area: string
  parameter: string
  description: string
  completion_date: string
  file: string
  status: string
  created_at: string
  updated_at: string
  deleted_at: any
  mil: Mil
  cem: Cem
  ncr_klhk_status_history: NcrKlhkStatusHistory[]
}

interface Mil {
  uuid: string
  name: string
}

interface Cem {
  uuid: string
  name: string
}

interface NcrKlhkStatusHistory {
  uuid: string
  status: string
  created_at: string
  updated_at: string
  deleted_at: any
  created_by: CreatedBy
}

interface CreatedBy {
  uuid: string
  name: string
  email: string
  role: string
}

const useAllKlhk = (filter: TopFilterOutput) => {
  const { _type, time, ...data } = filter
  const url = "/ncr-klhk/" + _type
  const { fetcher } = useAuth()
  const output = useSWR([url, JSON.stringify(data)], (url, param) =>
    fetcher()
      .get<ApiResponse<KLHKResponse[]>>(url, { params: JSON.parse(param) })
      .then(({ data }) => data.data)
  )
  return output
}

export default useAllKlhk
